// Handles case like "McDonalds DeWalt", "Twenty-One", and "Twenty One".
export function toTitleCase(str: string): string {
  return str
    .split(/\s+/) // Split by spaces
    .map(word =>
      word
        .split('-') // Handle hyphenated words
        .map(part =>
          part.length > 0
            ? part[0].toUpperCase() + part.slice(1) // Capitalize first letter only
            : '',
        )
        .join('-'),
    )
    .join(' ');
}
